import { render, staticRenderFns } from "./passenger-info.vue?vue&type=template&id=64924ae7&scoped=true"
import script from "./passenger-info.vue?vue&type=script&lang=js"
export * from "./passenger-info.vue?vue&type=script&lang=js"
import style0 from "./passenger-info.vue?vue&type=style&index=0&id=64924ae7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64924ae7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64924ae7')) {
      api.createRecord('64924ae7', component.options)
    } else {
      api.reload('64924ae7', component.options)
    }
    module.hot.accept("./passenger-info.vue?vue&type=template&id=64924ae7&scoped=true", function () {
      api.rerender('64924ae7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/intercity/components/passenger-info.vue"
export default component.exports